(() => {
  const root = document.documentElement;
  const mobile = matchMedia('(max-width: 749px)');
  const bars = '.otr-sticky, .pdm-sticky, .kbh__sticky, .kb-table-designer:not(.kb-mobile-modal-open)';
  const cookieSelector = '#shopify-pc__banner, .shopify-pc__banner__dialog';
  const observed = new WeakSet();
  let pending = false;
  const set = (name, value) => {
    const next = `${Math.ceil(value)}px`;
    if (root.style.getPropertyValue(name) !== next) root.style.setProperty(name, next);
  };
  const visibleRect = element => {
    const style = getComputedStyle(element);
    if (element.hidden || style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return null;
    const rect = element.getBoundingClientRect();
    return rect.width && rect.height && rect.bottom > 0 && rect.top < innerHeight ? rect : null;
  };
  const resize = new ResizeObserver(() => schedule());
  const watch = element => {
    if (element && !observed.has(element)) { observed.add(element); resize.observe(element); }
  };
  function update() {
    pending = false;
    let cookie = 0;
    document.querySelectorAll(cookieSelector).forEach(element => {
      watch(element);
      const rect = visibleRect(element);
      if (rect && rect.bottom >= innerHeight - 4) cookie = Math.max(cookie, innerHeight - rect.top + 8);
    });
    set('--kb-cookie-offset', mobile.matches ? cookie : 0);
    let obstruction = mobile.matches ? cookie : 0;
    if (mobile.matches && !document.body.classList.contains('kb-configurator-open')) {
      document.querySelectorAll(bars).forEach(element => {
        watch(element);
        const rect = visibleRect(element);
        const position = getComputedStyle(element).position;
        if (rect && (position === 'fixed' || position === 'sticky')) obstruction = Math.max(obstruction, innerHeight - rect.top);
      });
    }
    const chat = document.querySelector('shopify-chat');
    const activator = chat?.shadowRoot?.querySelector('[part~="activator"]');
    watch(activator);
    const chatHeight = activator?.getBoundingClientRect().height || 50;
    const chatBottom = Math.max(20, obstruction + 14);
    set('--kb-bottom-obstruction', obstruction);
    set('--kb-chat-lift', mobile.matches ? chatBottom - 20 : 0);
    set('--kb-actions-bottom', mobile.matches ? chatBottom + chatHeight + 12 : 200);
  }
  function schedule() {
    if (!pending) { pending = true; requestAnimationFrame(update); }
  }
  new MutationObserver(schedule).observe(document.body, {subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'open']});
  addEventListener('resize', schedule, {passive: true});
  addEventListener('scroll', schedule, {passive: true});
  visualViewport?.addEventListener('resize', schedule, {passive: true});
  mobile.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', schedule);
  update();
})();
